import HBIcon from "../../HBIcon";
/**
 * 表单的错误提示
 * @param {*} props
 * @returns
 */
export default function ErrMsg(props) {
  return (
    <div className="vertical-center">
      <HBIcon type="ic_Warning" style={{ fontSize: "16px" }} />
      {props.children}
    </div>
  );
}
